const creditotal = {
  FORMS: [],
  CSS: {
    id: '4cdfb11e1f3c000000007822',
    name: 'creditotal',
    avatar: {
      name: 'Alejandra',
      header: 'https://chatbotqa.gatblac.com/static/avatar/creditotal/avatar-reposo.png',
      new: 'https://chatbotqa.gatblac.com/static/avatar/creditotal/creditotal.gif',
      open: 'https://chatbotqa.gatblac.com/static/avatar/creditotal/avatar-activo.png',
      close: 'https://chatbotqa.gatblac.com/static/avatar/creditotal/avatar-reposo.png'
    },
    style: {
      score: {
        inactiveColor: '#fff',
        activeColor: '#dedb00',
        borderColor: '#dedb00'
      }
    }
  }
}

export default creditotal
